var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDatabase(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 41,
    viewBox: "0 0 42 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.7833 1.0625H7.21666C3.78329 1.0625 1 3.72403 1 7.00719V33.3678C1 36.651 3.78329 39.3125 7.21666 39.3125H34.7833C38.2167 39.3125 41 36.651 41 33.3678V7.00719C41 3.72403 38.2167 1.0625 34.7833 1.0625Z",
    stroke: "#19292C",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9338 13.0674L11.8963 27.2637C11.8963 29.1085 15.9546 30.6146 20.9713 30.6265C25.988 30.6385 30.0588 29.1523 30.063 27.3075L30.1005 17.4343",
    stroke: "#19292C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0799 13.1113C30.0758 14.9561 26.0049 16.4422 20.9882 16.4303C15.9716 16.4183 11.9091 14.9122 11.9174 13.0675C11.9216 11.2227 15.9966 9.73653 21.0091 9.74848C26.0216 9.76044 30.0883 11.2665 30.0841 13.1113",
    stroke: "#19292C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9171 20.1638C11.9129 22.0086 15.9712 23.5147 20.9879 23.5266C26.0046 23.5386 30.0754 22.0524 30.0796 20.2076",
    stroke: "#19292C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatabase);
export default __webpack_public_path__ + "static/media/database.98f6150652f570784fa27cc0ba0c1365.svg";
export { ForwardRef as ReactComponent };